export default __webpack_public_path__ + "static/media/ace_term.944b6b45.png";